module.exports = __webpack_public_path__ + "static/index/img/baikal-803.fc999778.jpg";